export const environment = {
  production: true,
  apiUrl: '/api',
  locale: 'cs',
  transitionScreenWaitTime: 5000,
  urlDeployment: 'https://service2.finbricks.com',
  sentryDsn: 'https://682406f9ae224ce9a0fc299ca55a78d7@o557728.ingest.sentry.io/4504683277385728',
  sentryEnv: 'PROD',
  cdnPath: 'https://cdn.finbricks.com'
};
